<template>
  <highcharts :options="option"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import highcharts3d from "highcharts/highcharts-3d";
import highcharts from "highcharts";
import { getCourceStudyDateView } from "@/api/comd.js";
highcharts3d(highcharts);
export default {
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataview: [
        {
          name: "婴幼儿生活辩护与回应",
          y: 72,
          sliced: true,
          selected: true,
          color: "#6177C6",
        },
        {
          name: "意外伤害预防与急救",
          y: 15,
          color: "#3854A9",
        },
        {
          name: "婴幼儿生活卫生饮食",
          y: 13,
          color: "#15BAC8",
        },
      ],
      option: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
            depth: 50,
          },
          backgroundColor: "#fff0",
          height: 250,
          width: 470,
        },
        title: {
          text: "",
        },
        tooltip: {
          // enabled: false,
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          style: {
            // color: "#fff"
          },
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b><br>{point.percentage:.1f} %",
              distance: "25%",
            },
          },
        },
        series: [
          {
            type: "pie",
            name: "课程学习人数占比",
            label: {},
            dataLabels: {
              enabled: true,
              color: "#ffffff",
              style: {
                fontSize: 12,
              },
            },
            data: this.dataview,
          },
        ],
      },
    };
  },
  created() {
    this.getCourceStudyDateViewHandel();

  },
  methods: {
    getColor(index) {
      var colorArr = [
        "#414DE6",
        "#2391FF",
        "#0ABAFF",
        "#19DAFC",
        "#5AD8A6",
        "#07E8AE",
        "#2EFFD0",
        "#05FF84",
        "#931266",
        "#F84466",
        "#F7517F",
        "#EB7375",
        "#F45D41",
        "#FF745A",
        "#FFC328",
        "#FFDF25",
        "#6912F4",
        "#8922EC",
        "#9F3DF2",
        "#AF6AF7",
        "#E47FC8",
        "#D397C2",
        "#F8DC8F",
        "#E7E3B7",
        "#6490F2",
        "#6DC8EC",
        "#00A8BD",
        "#5D7092",
        "#0677D5",
        "#F79708",
        "#1E9493",
      ];
      return colorArr[index];
    },
    async getCourceStudyDateViewHandel() {
      let res = await getCourceStudyDateView();
      let i = 0;
      this.dataview = res.data.map((en) => {
        let col = this.getColor(i);
        i++;
        return {
          name: en.courceName,
          y: en.rate,
          color: col ? col : this.createColorCode(),
        };
      });
      this.option = {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
            depth: 50,
          },
          backgroundColor: "#fff0",
          height: 250,
          width: 470,
        },
        title: {
          text: "",
        },
        tooltip: {
          // enabled: false,
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          style: {
            // color: "#fff"
          },
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b><br>{point.percentage:.1f} %",
              distance: "25%",
            },
          },
        },
        series: [
          {
            type: "pie",
            name: "课程学习人数占比",
            label: {},
            dataLabels: {
              enabled: true,
              color: "#ffffff",
              style: {
                fontSize: 12,
              },
            },
            data: this.dataview,
          },
        ],
      };
    },
    //生成不同的颜色代码
    createColorCode() {
      return (
        "rgb(" +
        [
          Math.round(Math.random() * 160),
          Math.round(Math.random() * 160),
          Math.round(Math.random() * 160),
        ].join(",") +
        ")"
      );
    },
  },
};
</script>

<style scoped>
</style>